import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import TextInput from '../../components/TextInput';
import ModalButtons from '../../components/Modal/ModalButtons';
import SelectBox from '../../components/SelectBox';

const AddUserModal = ({ data }) => {
	const {
		addUserModalStatus,
		userName,
		userRole,
		setUserRole,
		userCompany,
		setUserCompany,
		userEmail,
		setUserEmail,
		currentAdminCompany,
		availableCompanies,
		isProvider,
		airgap,
		closeModal,
		handleAddUser
	} = data;
	// Edit prefills [username, role, company]; create starts empty. On create the
	// email address is the username, so we show an Email field instead of Username.
	const isEdit = addUserModalStatus.data && addUserModalStatus.data.length === 3;
	return (
		<Modal show={addUserModalStatus.status}>
			<ModalHeading
				heading={`${addUserModalStatus.data && addUserModalStatus.data.length === 3
					? 'Edit ' + addUserModalStatus.data[0] + ' Data'
					: 'Register new user'} `}
				subHeading=''
			/>
			<ModalForm>
				<InputsSection style={{ alignItems: 'flex-start' }}>
					{isEdit ? (
						<TextInput
							icon='user'
							label={`Username`}
							placeholder={`Username`}
							value={userName.value}
							disabled={true}
							errorMessage={userName.error}
						/>
					) : airgap ? (
						<TextInput
							type='text'
							icon='user'
							label={`Username`}
							placeholder={`e.g. jsmith`}
							value={userEmail.value}
							onChange={(e) => {
								setUserEmail({ value: e.target.value });
							}}
							errorMessage={userEmail.error}
						/>
					) : (
						<TextInput
							type='email'
							icon='user'
							label={`Email (used as username)`}
							placeholder={`name@company.com`}
							value={userEmail.value}
							onChange={(e) => {
								setUserEmail({ value: e.target.value });
							}}
							errorMessage={userEmail.error}
						/>
					)}

					<SelectBox
						label={`Role`}
						value={userRole.value}
						onChange={(e) => {
							setUserRole({ value: e.target.value });
						}}
						errorMessage={userRole.error}>
						<option value='' disabled>
							Select user role
						</option>
						<option value='admin'>Admin</option>
						<option value='user'>User</option>
					</SelectBox>
				</InputsSection>

				{/* Company field — provider staff pick which company the user belongs
				    to; a Company Admin's users are always their own company. */}
				<InputsSection style={{ alignItems: 'flex-start' }}>
					{isProvider ? (
						// Provider staff see the company dropdown for create and edit
						<SelectBox
							label={`Company`}
							value={userCompany.value}
							onChange={(e) => {
								setUserCompany({ value: e.target.value });
							}}
							errorMessage={userCompany.error}>
							<option value='' disabled>
								Select company
							</option>
							{availableCompanies && availableCompanies.map((company, idx) => (
								<option key={idx} value={company}>
									{company}
								</option>
							))}
						</SelectBox>
					) : (
						// Non-FLC admin sees read-only field when editing
						addUserModalStatus.data && addUserModalStatus.data.length === 3 && (
							<TextInput
								icon='building'
								label={`Company`}
								placeholder={`Company`}
								value={userCompany.value}
								disabled={true}
								errorMessage={userCompany.error}
							/>
						)
					)}
				</InputsSection>

				{/* On create, the user is emailed a one-time link to set their own
				    password and activate the account. */}
				{!isEdit && (
					<InputsSection style={{ alignItems: 'flex-start' }}>
						<p style={{ margin: '4px 4px 0', fontSize: 12, color: '#64748b', lineHeight: 1.5 }}>
							{airgap
								? 'Air-gap mode: the account is created with a one-time temporary password shown once after you save. Hand it to the user — no email is sent, and they set their own password at first login.'
								: "We'll email this address a secure link to set a password and activate the account. Their email address is also their username for signing in."}
						</p>
					</InputsSection>
				)}
				<ModalButtons
					submitButtonLabel={`${addUserModalStatus.data && addUserModalStatus.data.length === 3
						? 'Edit Account'
						: 'Create Account'} `}
					onSubmit={handleAddUser}
					cancelButtonLabel='Cancel'
					onCancel={closeModal}
				/>
			</ModalForm>
		</Modal>
	);
};

export default AddUserModal;
